import { useTranslation } from "@/hooks/useTranslation"
import { Filter } from "@/organisms/FilterNew/Filter"
import { SmartSearch } from "@/organisms/SmartSearch"
import { TYPE_FILTER_KEY } from "../../QuickWinsDrawer.constants"
import {
  getQuickWinsFilters,
  getTypeFilterOptions
} from "./QuickWinsFilterBar.helpers"

import styles from "../../QuickWinsDrawer.module.scss"

import type { QuickWinsDrawerMeta } from "../../QuickWinsDrawer.types"
import type { QuickWinsFilterBarProps } from "./QuickWinsFilterBar.types"

export const QuickWinsFilterBar = ({
  record,
  onChange,
  filterProviderKey,
  smartFilters
}: QuickWinsFilterBarProps) => {
  const { t } = useTranslation()
  const meta = (
    record as { id?: string; meta?: QuickWinsDrawerMeta } | undefined
  )?.meta
  const metaKey = `${record?.id}-${meta?.typeFilter || ""}-${meta?.searchQuery || ""}`
  const filters = getQuickWinsFilters(t)
  const initialState = smartFilters

  return (
    <div className={styles.filterWrapper}>
      {/* Intentional: Key remount resets Filter.Provider when meta changes (e.g. opening from banner).
          Filter.Provider has no controlled reset API — numeric key increment is the simplest approach (Round 16). */}
      <Filter.Provider
        key={`${metaKey}-${filterProviderKey}`}
        initialState={initialState}
        useQueryString={false}
        onChange={onChange}
      >
        <Filter.Template
          inline
          search={<SmartSearch id="QuickWinsDrawerFilter" filters={filters} />}
        >
          <Filter.Checkbox
            keyFilter={TYPE_FILTER_KEY}
            items={getTypeFilterOptions(t)}
            placeHolderDefaultValue={t("quickWins.filter.quickWinType")}
            placement="QuickWinsDrawer"
            order="none"
          />
        </Filter.Template>
      </Filter.Provider>
    </div>
  )
}
